import Common from '../../Common';

interface Search {
	users: id[]
}

interface Search {
	limit?: number,
	limit_from?: number,
	search?: string,
	order_dir?: string,
	show?: string,
	datetime_from?: string,
	datetime_to?: string,
}

interface Download extends Search {
	format: string
}

const defaultSearch = {
	limit: 25,
	limit_from: 0,
	users: [],
}

const UserReports = class extends Common {
	browse = (companyId: id, search: Search = defaultSearch): CustomResponse<BrowseResponse & { calls: CompanyUserReportsHistory[] }> =>
		this.get(`/company/${companyId}/userreports`, search)

	download = (companyId: id, search: Download) =>
		this.get(`/company/${companyId}/userreports/download`, search, { responseType: 'blob' })
}

export default UserReports
